module.exports = __webpack_public_path__ + "static/media/browser-rods-cones.3002057a.png";